export enum GenericScreenTypes {
  INCLINED_SCREEN = 'Inclined screen',
  HORIZONTAL_SCREEN = 'Horizontal screen',
  SCALPING_SCREEN = 'Scalping screen',
  MULTISLOPE_SCREEN = 'Multislope screen',
  GRIZZLY_SCREEN = 'Grizzly screen',
}

export interface GenericScreenDataInterface {
  availableDecks: number[];
}

export interface GenericScreenMapInterface {
  [modelType: string]: GenericScreenDataInterface;
}

export interface GenericScreenDeckInterface {
  separationSize: number;
  display: {
    separationSize: boolean;
  };
}

export interface GenericScreenDeckMapInterface {
  0: GenericScreenDeckInterface;
  1: GenericScreenDeckInterface;
  2: GenericScreenDeckInterface;
  3: GenericScreenDeckInterface;
}
